/*
 * File: 基础设置-组织架构-组织架构
 */
<template>
    <div class="organization">
        <Paper class="organization-paper">
            <div class="organization-paper-tree" v-loading="loadingTree">
                <div class="organization-paper-tree-search">
                    <el-input v-model="filterText" placeholder="请输入组织名称" @keydown.enter.native="handleSearch" style="width: calc(100% - 40px);margin-right: 10px;" />
                    <lotsButton
                        v-has="authorityCode.add"
                        type="primary"
                        size="mini"
                        title="新增"
                        @click="handleAdd">
                        <span class="icon iconfont">&#xe66a;</span>
                    </lotsButton>
                </div>
                <el-tree
                    ref="treeRef"
                    node-key="orgCode"
                    :props="{
                        children: 'child',
                        label: 'deptName'
                    }"
                    :data="treeData"
                    :filter-node-method="filterNode"
                    :default-expanded-keys="defaultExpandedKeys"
                    @node-click="clickNode"
                    @node-expand="clickExpand"
                    @node-collapse="clickExpand"
                >
                    <span slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <lotsButton
                            v-has="authorityCode.edit"
                            type="text"
                            size="medium"
                            title="编辑"
                            icon="el-icon-edit"
                            style="margin-left: 5px;"
                            @click.stop="handleEdit(node, data)"
                        />
                        <lotsButton
                            v-has="authorityCode.delete"
                            type="text"
                            size="medium"
                            title="删除"
                            icon="el-icon-delete"
                            style="margin-left: 5px;"
                            @click.stop="handleDelete(node, data)"
                        />
                    </span>
                </el-tree>
            </div>
            <div class="organization-paper-table">
                <div class="organization-paper-table-header">
                    <div style="width: 200px;">
                        <span style="font-size: 18px;font-weight: 600;">用户列表</span>
                        <span style="color: #888;">{{ `（${userList.pageTotal}人）` }}</span>
                    </div>
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        @search-change="userList.searchList"
                    />
                    <div>
                        <lotsButton
                            v-has="authorityCode.export"
                            type="primary"
                            size="mini"
                            title="导出"
                            icon="el-icon-download"
                            @click="handleExport">导出
                        </lotsButton>
                    </div>
                </div>
                <div style="height: calc(100% - 40px);">
                    <table-box
                        ref="tableBoxRef"
                        :selection="config.selection"
                        :index="config.index"
                        :columns="config.columns"
                        :actions="config.actions"
                        v-loading="userList.tableLoading"
                        :rows="userList.totalData"
                        @action-click="handleActive"
                    />
                    <lots-pagination
                        style="text-align: right;"
                        @size-change="userList.sizeChange"
                        :current-page.sync="userList.pageNo"
                        @current-change="userList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="userList.pageTotal"
                    />
                </div>
            </div>
        </Paper>

        <!-- 新建/编辑部门 -->
        <DepartmentDialog ref="departmentDialogRef" @confirm="getTreeData" />
        <!-- 编辑用户 -->
        <UserDialog ref="userDialogRef" @confirm="userList.getList()" />
    </div>
</template>

<script>
import { ref, reactive, onMounted, onActivated } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import _ from 'lodash';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import DepartmentDialog from './component/departmentDialog.vue';
import UserDialog from './component/userDialog.vue';
import { getOrganizationTree, getUserList, deleteOrganization, updateUserStatus, exportUserList } from '@mdm/api/basicSettings/organization.js';
import { config as configStatic } from './config';

export default {
    name: 'organization',
    components: {
        Paper,
        searchBox,
        lotsButton,
        tableBox,
        lotsPagination,
        DepartmentDialog,
        UserDialog
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.organization);
        const config = reactive(configStatic);
        const treeData = ref([]);
        const filterText = ref('');
        const loadingTree = ref(false);
        const currentNode = ref({});
        const defaultExpandedKeys = ref([]);

        // 组织查询
        const handleSearch = () => {
            setupContext.refs.treeRef.filter(filterText.value);
        };
        // 加载树节点
        const getTreeData = (flag) => {
            loadingTree.value = true;
            getOrganizationTree().then(
                (res) => {
                    treeData.value = res?.data || [];
                    config.department.formList.find((v) => v.prop === 'parentName').options = treeData.value;
                    defaultExpandedKeys.value = [];
                    if (flag) {
                        defaultExpandedKeys.value = findParentTree(treeData.value, { orgCode: currentNode.value.orgCode });
                    }
                }
            ).finally(() => {
                loadingTree.value = false;
            });
        };
        // 过滤树节点
        const filterNode = (value, data) => {
            if (!value) return true;
            return data.deptName.indexOf(value) !== -1;
        };
        // 点击树节点
        const clickNode = (data, node) => {
            // 判断是否为叶子节点
            if (node.isLeaf) {
                clickExpand(data, node);
            }
        };
        // 展开与收起树节点
        const clickExpand = (data, node) => {
            if (data.orgCode !== currentNode.value.orgCode) {
                userList.totalData.value = [];
                currentNode.value = { ...data, level: node.level };
                userList.getList();
            }
        };
        // 新增
        const handleAdd = () => {
            setupContext.refs.departmentDialogRef.show({ type: 'add' });
        };
        // 编辑部门
        const handleEdit = (node, data) => {
            const parent = findParentTree(treeData.value, { orgCode: data.orgCode });
            // 去掉当前节点orgCode
            parent.pop();
            const parentName = node.level === 1 ? '无上级部门(根节点)' : parent;
            setupContext.refs.departmentDialogRef.show({ ...data, level: node.level, parentName, type: 'edit' });
        };
        // 删除部门
        const handleDelete = (node, data) => {
            MessageBox.confirm('该部门包含子部门或用户，删除后不可恢复，是否继续删除？', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteOrganization({ id: data.id }).then((res) => {
                    if (res && +res.code === 0) {
                        getTreeData(true);
                        Message.success('删除成功');
                    }
                });
            });
        };
        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.tableBoxRef.$refs.elTable.doLayout(); // 解决表格错位
                });
            };
        }
        const userList = new AccountListClass({
            Api: {
                listApi: getUserList // 查询接口
            }
        });
        // 查询参数转换
        const searchDataFormat = (condition = {}, params = {}) => {
            const newParams = { ...condition, ...params, orgCode: currentNode.value.orgCode };
            Object.keys(newParams).forEach(v => {
                if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                    delete newParams[v];
                }
            });
            return newParams;
        };
        // 导出
        const handleExport = async () => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = userList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            const excelTitleList = otherUtils.sortColumnsByFixed(config.columns)?.map((item) => ({
                name: item.name,
                property: item.property
            }));
            const params = {
                ...searchDataFormat(newData),
                deleteFlag: 0,
                excelTitleList
            };
            exportUserList(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => {});
        };
        // 操作项
        const handleActive = (event, row) => {
            // 编辑
            if (event === 'edit') {
                config.user.formList.find((v) => v.prop === 'superiorName').beforeRequest = (params) => {
                    params.isManage = 1;
                    params.orgCode = row.orgCode;
                    return params;
                };
                setupContext.refs.userDialogRef.show(row);
            }
            // 禁用
            if (event === 'disabled') {
                handleEabled(row);
            }
            // 启用
            if (event === 'enabled') {
                handleEabled(row);
            }
        };
        // 启用/禁用
        const handleEabled = (row) => {
            updateUserStatus({ id: row.id }).then((res) => {
                if (res && +res.code === 0) {
                    userList.getList();
                    Message.success('操作成功');
                }
            });
        };
        /**
         * 递归获取当前节点->父节点->根节点完整某属性值
         * @param {Array} data - 需求递归的数据
         * @param {Object} childNode - 当前子节点，如{ orgCode: '1246471846779' }
         * @param {Array} parents - 找到的父节点某属性值
         * @returns {Array} - 找到的父节点
         */
        const findParentTree = (data, childNode, parents = []) => {
            const key = Object.keys(childNode)?.[0];
            for (const t of data) {
                if (t[key] === childNode[key]) {
                    // 找到目标子节点了，返回当前节点
                    return [...parents, t[key]];
                } else if (t.child && t.child.length) {
                    // 递归调用，继续查找子节点
                    const result = findParentTree(t.child, childNode, [...parents, t[key]]);
                    if (result) {
                        return result;
                    }
                }
            }
            // 未找到包含自定义属性的子节点
            return null;
        };

        onActivated(() => {
            setupContext.refs.tableBoxRef.$refs.elTable.doLayout(); // 解决表格错位
        });
        onMounted(() => {
            getTreeData();
            setupContext.refs.searchBox.submitSearch();
        });

        return {
            config,
            authorityCode,
            userList,
            treeData,
            filterText,
            loadingTree,
            defaultExpandedKeys,
            getTreeData,
            handleSearch,
            filterNode,
            clickNode,
            clickExpand,
            handleAdd,
            handleEdit,
            handleDelete,
            handleExport,
            handleActive
        };
    }
};
</script>

<style lang="less">
.organization {
    width: 100%;
    .organization-paper {
        height: 100%;
        display: flex;
        padding: 0;
    }
    .organization-paper-tree {
        width: 300px;
        border-right: 1px solid #f5f6f7;
        height: 100%;
        overflow: scroll;
    }
    .organization-paper-tree-search {
        padding: 10px;
    }
    .el-tree {
        font-size: 14px;
    }
    .organization-paper-table {
        height: calc(100% - 30px);
        width: calc(100% - 301px);
        padding: 10px 20px 20px;
    }
    .organization-paper-table-header {
        display: flex;
        justify-content: space-between;
    }
    .model-table-search {
        flex: 1;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .table-box {
        height: calc(100% - 50px);
        overflow-y: auto;
        margin-bottom: 20px;
    }
}
</style>
